import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import PickListPicking from '../entities/pick-list-picking';

interface RefPickListState extends ListState<any> {
	plIdsSelected: [];
	plPickings: Array<PickListPicking>;
	viewPlPicking: PickListPicking;
}
class RefPickListModule extends ListModule<RefPickListState, any, any> {
	state = {
		totalCount: 0,
		currentPage: 1,
		pageSize: 10,
		list: new Array<any>(),
		loading: false,
	};
	actions = {
		async getAll(context: ActionContext<RefPickListState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/SoPickList/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
	};
	mutations = {
		setCurrentPage(state: RefPickListState, page: number) {
			state.currentPage = page;
		},
		setPageSize(state: RefPickListState, pagesize: number) {
			state.pageSize = pagesize;
		},
		refreshListData(state: RefPickListState)
        {
            state.list = new Array<any>();
        },
	};
}
const pickListModule = new RefPickListModule();
export default pickListModule;
